module.exports = __webpack_public_path__ + "img/award.bafdff54.png";